var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNetworkPlanning(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 5.33333C0 2.38782 2.38781 0 5.33333 0H22.6667C25.6122 0 28 2.38781 28 5.33333V22.6667C28 25.6122 25.6122 28 22.6667 28H5.33333C2.38782 28 0 25.6122 0 22.6667V5.33333Z",
    fill: "#F8E8E9"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8069_15908)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.7548 14.4529H14.151V19.8868H14.7548V14.4529Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1003 8.02446L19.6733 7.59753L15.1451 12.1257L15.5721 12.5527L20.1003 8.02446Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7925 14.3332L13.3656 13.9062L7.59862 19.6732L8.02555 20.1002L13.7925 14.3332Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4586 11.8242L10.1379 8.50354L9.71101 8.93047L13.0317 12.2511L13.4586 11.8242Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7984 18.1634L15.5825 13.9475L15.1556 14.3744L19.3715 18.5903L19.7984 18.1634Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4905 9.01887C21.3242 9.01887 21.9999 8.34307 21.9999 7.50943C21.9999 6.6758 21.3242 6 20.4905 6C19.6569 6 18.9811 6.6758 18.9811 7.50943C18.9811 8.34307 19.6569 9.01887 20.4905 9.01887Z",
    fill: "#BD1D23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4528 21.9999C15.2864 21.9999 15.9622 21.3242 15.9622 20.4905C15.9622 19.6569 15.2864 18.9811 14.4528 18.9811C13.6192 18.9811 12.9434 19.6569 12.9434 20.4905C12.9434 21.3242 13.6192 21.9999 14.4528 21.9999Z",
    fill: "#BD1D23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.50943 21.3962C8.34307 21.3962 9.01887 20.7204 9.01887 19.8868C9.01887 19.0531 8.34307 18.3773 7.50943 18.3773C6.6758 18.3773 6 19.0531 6 19.8868C6 20.7204 6.6758 21.3962 7.50943 21.3962Z",
    fill: "#BD1D23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.6227 9.32072C10.1229 9.32072 10.5284 8.91524 10.5284 8.41506C10.5284 7.91488 10.1229 7.5094 9.6227 7.5094C9.12252 7.5094 8.71704 7.91488 8.71704 8.41506C8.71704 8.91524 9.12252 9.32072 9.6227 9.32072Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.283 18.9811C19.7832 18.9811 20.1886 18.5756 20.1886 18.0755C20.1886 17.5753 19.7832 17.1698 19.283 17.1698C18.7828 17.1698 18.3773 17.5753 18.3773 18.0755C18.3773 18.5756 18.7828 18.9811 19.283 18.9811Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4529 11.1321C15.6199 11.1321 16.5662 12.0783 16.5662 13.2454C16.5661 14.4124 15.6199 15.3586 14.4529 15.3586C13.2858 15.3586 12.3396 14.4124 12.3396 13.2454C12.3396 12.0783 13.2858 11.1321 14.4529 11.1321ZM14.4529 12.0383C13.786 12.0383 13.245 12.5785 13.2449 13.2454C13.2449 13.9123 13.786 14.4534 14.4529 14.4534C15.1197 14.4532 15.6599 13.9122 15.6599 13.2454C15.6598 12.5786 15.1196 12.0385 14.4529 12.0383Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8069_15908"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(6 6)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNetworkPlanning);
export default __webpack_public_path__ + "static/media/networkPlanning.152ed9661480782fc51b1ef20a8f54bb.svg";
export { ForwardRef as ReactComponent };